import { Typography } from '@mui/material';
import Prompt, { PromptProps } from '../../lib/helper/components/Prompt';

export type LeavePromptProps = Pick<PromptProps, 'onConfirm' | 'onCancel' | 'when'>;

const LeavePrompt = ({ when, onCancel, onConfirm }: LeavePromptProps) => (
    <Prompt
        when={when}
        cancelLabel="No"
        confirmLabel="Yes"
        onConfirm={onConfirm}
        onCancel={onCancel}
        navigateOnCancel
        waitConfirmResolve>
        <Typography>Do you want to save your work?</Typography>
    </Prompt>
);

export default LeavePrompt;
